import { Box } from '../../../common/ui/Box';
import { PriceBoxContent } from '../PriceBoxContent';
import { theme } from '../../../common/ui/theme';

export const PriceBox = ({ price }) => {
    return (
        <Box
            position="relative"
            paddingTop={5}
            paddingLeft={5}
            paddingRight={5}
            width="240px"
            height="220px"
            borderRadius="4px"
            border="1px solid"
            borderColor="border.muted"
            boxShadow={theme.shadows.medium}
        >
            <PriceBoxContent price={price} />
        </Box>
    );
};
